import React, { memo } from 'react';
import roadmapStyles from 'app/components/RoadmapCard/Roadmap.module.scss';
import type { MonthSectionWidth } from '../utils/useMonthSectionWidths';
import styles from '../MonthlyRoadmap.module.scss';

interface MonthlyTimelineGridLineFillerProps {
  monthSections: MonthSectionWidth[];
  bodyExtensionPx: number;
  gapWidth: number;
}

export const MonthlyTimelineGridLineFiller = memo(
  ({
    monthSections,
    bodyExtensionPx,
    gapWidth
  }: MonthlyTimelineGridLineFillerProps) => {
    return (
      <div className={roadmapStyles.gridLineFiller}>
        <div className={roadmapStyles.gridLineFillerHeader} />
        <div
          className={`${roadmapStyles.gridLineFillerColumns} ${styles.monthlyGridLineFillerColumns}`}
        >
          {monthSections.map(section => (
            <div
              key={section.month.key}
              className={roadmapStyles.gridLineFillerColumn}
              style={{ width: `${section.widthPx}px` }}
            />
          ))}
          {bodyExtensionPx > 0 && (
            <div
              className={roadmapStyles.gridLineFillerColumn}
              style={{ width: `${bodyExtensionPx}px` }}
            />
          )}
          <div
            className={roadmapStyles.gridLineFillerGap}
            style={{ width: gapWidth ? `${gapWidth}px` : undefined }}
          />
        </div>
      </div>
    );
  }
);
